var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LoadingContainer',{attrs:{"is-loading":_vm.isLoading}},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-full"},[_c('product-info',{attrs:{"product":_vm.product}})],1)]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }